module.exports = __webpack_public_path__ + "img/hint-four.b6bd8e9e.jpg";